import React from 'react';
import {
    Router,
    Switch,
    Route,
    Redirect,
} from "react-router-dom";

import '@icon/material-icons/material-icons.css';
import './scss/app.scss';
import {history} from "./history";
import Login from "./components/pages/Login/Login";
import WorkingHours from "./components/pages/WorkingHours/WorkingHours";
import Controlling from "./components/pages/Controlling/Controlling";
import Employees from "./components/pages/Employees/Employees";
import OnePageLayout from "./components/template/AppLayout/OnePageLayout";
import {useSelector} from "react-redux";

function App() {
    const { user } = useSelector((state) => state.auth);
    console.log('user islisted = ', user.is_listed);
    let defaultRoute = user.is_listed ? '/working-hours' : '/controlling';

    if (user.is_listed === undefined) {
        defaultRoute = '/';
    }

    return (
        <Router history={history}>
          <Switch>
              <Route path="/" exact>
                    <Redirect to={defaultRoute} />
              </Route>
              <Route path="/login">
                   <Login />
              </Route>
              <Route path="/">
                  <OnePageLayout>
                      <Route path="/working-hours" component={WorkingHours} />
                      <Route path="/controlling" component={Controlling} />
                      <Route path="/employees" component={Employees}/>
                  </OnePageLayout>
              </Route>
          </Switch>
        </Router>
    );
}

export default App;
